/**
 * @description 默认头像常量
 */

export const defaultAvatar = `${process.env.VUE_APP_LOWER_GRADE_URL}/common-static/images/default_avatar.png`;
export const searchNoData = `${process.env.VUE_APP_LOWER_GRADE_URL}/common-static/images/search_no_data.png`;
